// extracted by mini-css-extract-plugin
export var details = "_h3-0";
export var inspectorPopover = "_h3-1";